export default __webpack_public_path__ + "img/eb53b25a930cc4e97e6d5e04ee334963.png";